import { Link, NavLink, useNavigate } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Globe } from "lucide-react";
import { useT } from "@/i18n";

const pill = ({ isActive }) =>
  `px-4 py-2 rounded-full font-bold transition-colors ${isActive ? "bg-blue-600 text-white" : "text-blue-900 hover:bg-sky-100"}`;

export default function Nav() {
  const { lang, setLang, t } = useT();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-sky-400 px-3 sm:px-6 pt-3 pb-2">
      <div className="max-w-6xl mx-auto bg-white rounded-full shadow-lg px-4 sm:px-6 py-2 flex items-center justify-between gap-3">
        <Link to="/" className="font-fredoka font-bold text-2xl sm:text-3xl" data-testid="nav-logo">
          <span className="bubble-text-sm text-yellow-400">Lumi</span>
          <span className="text-sky-500">&</span>
          <span className="bubble-text-sm text-sky-500">Spark</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/" end className={pill} data-testid="nav-home">{t.nav.home}</NavLink>
          <Show when="signed-in">
            <NavLink to="/dashboard" className={pill} data-testid="nav-dashboard">{t.nav.dashboard}</NavLink>
          </Show>
          <NavLink to="/parents" className={pill} data-testid="nav-parents">{t.nav.parents}</NavLink>
        </nav>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setLang(lang === "es" ? "en" : "es")}
            className="bg-sky-100 hover:bg-sky-200 rounded-full px-3 py-2 flex items-center gap-1.5 font-bold text-sm text-blue-900"
            data-testid="language-switcher"
            aria-label="Toggle language"
          >
            <Globe className="w-4 h-4" />
            {lang.toUpperCase()}
          </button>
          <Show when="signed-out">
            <button
              onClick={() => navigate("/sign-in")}
              className="bg-blue-600 hover:bg-blue-700 rounded-full px-5 py-2 font-bold text-sm text-white"
              data-testid="nav-login-btn"
            >
              {t.nav.login}
            </button>
          </Show>
          <Show when="signed-in">
            <UserButton />
          </Show>
        </div>
      </div>
    </header>
  );
}
